import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Music2 } from 'lucide-react';
import { BUSINESS_INFO, OPENING_HOURS, NAV_LINKS } from '../../utils/constants';
import WhatsAppIcon from '../ui/WhatsAppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61581426567365', icon: Facebook },
    { name: 'Instagram', url: 'https://www.instagram.com/aramobilevaleting', icon: Instagram },
    { name: 'TikTok', url: 'https://www.tiktok.com/@ara.mobilevaleting', icon: Music2 },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/assets/images/logo.png"
                alt="ARA Mobile Valeting"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <h3>ARA Mobile Valeting</h3>
            </div>
            <p>
              Professional mobile car valeting delivering luxury shine to your
              doorstep across Sheffield & surrounding areas.
            </p>

          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <ul>
              <li>
                <a
                    href={BUSINESS_INFO.whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-flex', marginTop: '1rem' }}
                    >
                    <button className="btn btn-whatsapp btn-sm">
                      <WhatsAppIcon size={16} />
                      WhatsApp Us
                    </button>
                  </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS_INFO.email}`}>
                  <Mail size={16} />
                  {BUSINESS_INFO.email}
                </a>
              </li>
              <li>
                <span style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', fontSize: '0.875rem', color: 'var(--gray)' }}>
                  <MapPin size={16} style={{ flexShrink: 0, marginTop: '0.2rem' }} />
                  {BUSINESS_INFO.address}
                </span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Opening Hours</h3>
            <ul>
              <li>
                <span style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', fontSize: '0.875rem' }}>
                  <Clock size={16} style={{ flexShrink: 0, marginTop: '0.2rem', color: 'var(--gold)' }} />
                  <span>
                    <strong style={{ color: 'var(--white)' }}>{OPENING_HOURS.weekday.days}</strong><br />
                    <span style={{ color: 'var(--gray)' }}>{OPENING_HOURS.weekday.hours}</span>
                  </span>
                </span>
              </li>
              <li style={{ marginTop: '0.75rem' }}>
                <span style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', fontSize: '0.875rem' }}>
                  <Clock size={16} style={{ flexShrink: 0, marginTop: '0.2rem', color: 'var(--gold)' }} />
                  <span>
                    <strong style={{ color: 'var(--white)' }}>{OPENING_HOURS.weekend.days}</strong><br />
                    <span style={{ color: 'var(--gray)' }}>{OPENING_HOURS.weekend.hours}</span>
                  </span>
                </span>
              </li>
            </ul>

            <div className="social-media-links">
              {socialLinks.map((social) => {
              const Icon = social.icon;
             const canRender = Icon && (typeof Icon === 'function' || (typeof Icon === 'object' && Icon.$$typeof));
            if (!canRender) {
              console.error('[Footer] Invalid social icon for:', social.name, Icon);
              return null;
                }
              return (
             <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-link"
                    aria-label={social.name}
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
        <p>© {currentYear} {BUSINESS_INFO.name}. All rights reserved.</p>
        <p style={{ marginTop: '0.25rem' }}>
          Professional Mobile Car Valeting Services | {BUSINESS_INFO.website}
        </p>
        <p style={{ marginTop: '0.75rem', fontSize: '0.8125rem' }}>
          Designed &amp; Developed by{' '}
          <a
            href="https://eddiedev.tech"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-credit-link"
          >
            EddieDev
          </a>
        </p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;